import styled from "styled-components";
import { colorVariables } from "../styles/variables";
import { Link } from "react-router-dom";
import BackImg from "../assets/back-btn.png";
import NextImg from "../assets/back-btn.png";
import ConnectImg from "../assets/connect-btn.png";
import Play from "../assets/play-btn.png";

export const ButtonElement = styled(Link)`
  margin: ${(props) => props.margin};

  width: 100%;
  height: 100%;

  background: url(${(props) => props.imgurl});

  background-image: url(${({ imgurl }) => imgurl});
  background-repeat: no-repeat;
  background-position: 100%;
  background-size: cover ;


  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  width: ${(props) => props.width ?? "192px"};
  height: 52px;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: ${(props) => props.zIndex ?? "0"};
`;


// const Button = ({ children, url, onClick }) => {
//   const handleClick = (event) => {
//     // Trigger custom onClick logic if provided
//     if (onClick) {
//       onClick(event);
//     }

//     // Navigate to the provided URL if specified
//     if (url) {
//       window.location.href = url;
//     }
//   };

//   return (
//     <ButtonContainer>
//       <ButtonElement as="button" onClick={handleClick}>

const Button = ({
  children,
  url,
  onClick,
  bColor,
  color,
  zIndex,
  bbColor,
  imgurl,
  margin,
  width,
}) => {
  return (
    <ButtonContainer zIndex={zIndex} bbColor={bbColor} width={width}>
      <ButtonElement
        to={url}
        onClick={onClick}
        bColor={bColor}
        color={color}
        imgurl={imgurl}
        margin={margin}
      >
        {children}
      </ButtonElement>
    </ButtonContainer>
  );
};

export default Button;
